import Header from './Header'
import Metadata from './Metadata'
import Title from './Title'

export const SimpleListHeader = Object.assign(Header, {
  Title,
  Metadata,
})

try{ SimpleListHeader.displayName ||= 'SimpleListHeader' } catch {}